import React, { useContext, useState } from "react";
import { useCommonContext } from "../../../context/CommonContext";
import ai from "../../../assets/AI.png";
import search from "../../../assets/search.png";
import micIcon from "../../../assets/microphone.png";
import uploadIcon from "../../../assets/file.png";
import "./SearchInput.css";
import arrow from "../../../assets/arrow.png";

const SearchInput = () => {
  const {
    searchTerm,
    setSearchTerm,
    setIsAIsearch,
    showUpload,
    setShowUpload,
    sanitizeInput,
  } = useCommonContext();
  const [searchOption, setSearchOption] = useState("Eeezo AI");
  const [iconType, setIconType] = useState(ai);
  const [showOption, setShowOption] = useState(false);

  const changesearchterm = (value) => {
    const sanitizedValue = sanitizeInput(value);
    setSearchTerm(sanitizedValue);
  };

  const changesearchtype = (value) => {
    if (value === "eeezo_ai") {
      setSearchOption("Eeezo AI");
      setIconType(ai);
      setIsAIsearch(true);
    } else {
      setSearchOption("Search");
      setIconType(search);
      setIsAIsearch(false);
    }
    setShowOption(!showOption);
  };

  const toggleUploadView = () => {
    setShowUpload(true);
  };

  var [isUploaded, setIsUploaded] = useState(false);
  var [resumeFiles, setResumeFiles] = useState([]);

  var handleUploadClick = () => {
    setIsUploaded(true);
  };

  var handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  var handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    var droppedFiles = e.dataTransfer.files;
    if (droppedFiles.length > 0) {
      setResumeFiles(Array.from(droppedFiles));
    }
  };

  var handleFileInputChange = (e) => {
    var selectedFiles = e.target.files;
    if (selectedFiles.length > 0) {
      setResumeFiles(Array.from(selectedFiles));
    }
  };

  var handleDivClick = () => {
    document.getElementById("fileInput").click();
  };

  var saveResume = () => {
    console.log(resumeFiles, "resumeFiles");
  };

  return (
    <>
      {!showUpload ? (
        <div className="search-container">
          {/* Search Type Dropdown */}
          <div className="search-dropdown">
            <div className="dropdown-content">
              <div className="dropdown-icon">
                <img src={iconType} alt="search type" />
              </div>
              <div className="dropdown-text">{searchOption}</div>
              <div
                className="dropdown-arrow"
                onClick={() => setShowOption(!showOption)}
              >
                <img src={arrow} alt="dropdown arrow" />
              </div>
            </div>
            {showOption && (
              <div className="dropdown-options">
                <span
                  className="option-search-type"
                  onClick={() => changesearchtype("eeezo_ai")}
                >
                  Eeezo AI
                </span>
                <span
                  className="option-search-type"
                  onClick={() => changesearchtype("search")}
                >
                  Search
                </span>
              </div>
            )}
          </div>

          {/* Search Input */}
          <div className="search-input-container">
            <input
              type="text"
              aria-label="Search"
              className="search-input"
              placeholder="Search"
              value={searchTerm}
              onChange={(e) => changesearchterm(e.target.value)}
            />
            <div className="search-icons">
              <div className="mic-icon">
                <img src={micIcon} alt="Mic" />
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="upload-container">
          <div
            onClick={handleDivClick}
            onDragOver={handleDragOver}
            onDrop={handleDrop}
            className="upload-area"
          >
            <svg
              width="79"
              height="79"
              viewBox="0 0 79 79"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clipPath="url(#clip0_1599_7728)">
                <path
                  d="M46.0039 19.5781H52.5039V26.0781H68.7539C69.6159 26.0781 70.4425 26.4205 71.052 27.03C71.6615 27.6395 72.0039 28.4662 72.0039 29.3281V53.7031L52.5039 42.3281L52.6209 68.5296L59.8456 61.5421L65.6371 71.5781H29.7539C28.8919 71.5781 28.0653 71.2357 27.4558 70.6262C26.8463 70.0167 26.5039 69.1901 26.5039 68.3281V52.0781H20.0039V45.5781H26.5039V29.3281C26.5039 28.4662 26.8463 27.6395 27.4558 27.03C28.0653 26.4205 28.8919 26.0781 29.7539 26.0781H46.0039V19.5781ZM72.0039 56.4266V68.3281C72.0042 68.6668 71.9516 69.0034 71.8479 69.3259L65.4779 58.2954L72.0039 56.4266ZM13.5039 45.5781V52.0781H7.00391V45.5781H13.5039ZM13.5039 32.5781V39.0781H7.00391V32.5781H13.5039ZM13.5039 19.5781V26.0781H7.00391V19.5781H13.5039ZM13.5039 6.57812V13.0781H7.00391V6.57812H13.5039ZM26.5039 6.57812V13.0781H20.0039V6.57812H26.5039ZM39.5039 6.57812V13.0781H33.0039V6.57812H39.5039ZM52.5039 6.57812V13.0781H46.0039V6.57812H52.5039Z"
                  fill="#059669"
                />
              </g>
              <defs>
                <clipPath id="clip0_1599_7728">
                  <rect
                    width="78"
                    height="78"
                    fill="white"
                    transform="translate(0.503906 0.078125)"
                  />
                </clipPath>
              </defs>
            </svg>
            <p className="upload-text">Drag and Drop or choose files</p>
            <input
              type="file"
              id="fileInput"
              onChange={handleFileInputChange}
              className="file-input-hidden"
            />
          </div>
        </div>
      )}
    </>
  );
};

export default SearchInput;
